import React, { FC, useState } from 'react'
import { isMobile } from 'react-device-detect'

import GenericInput from '../../../GenericComponents/GenericInput'

import { WizzardPageBox } from '../style/UserWIzzardStyle'

interface WizzardPage0Interface {
  setUserName: Function
  getUserName: string
}

const WizzardPage0: FC<WizzardPage0Interface> = ({
  getUserName,
  setUserName,
}) => {
  return (
    <WizzardPageBox>
      <GenericInput
        onChange={(e: any) => setUserName(e.target.value)}
        placeholder={'Twoje imię'}
        tAlign={'center'}
        fSize={isMobile ? '3.3rem' : '2.5rem'}
        autoFocus
        className={'no-border color-white font-big-always'}
        margin={window.innerWidth < 400 ? '0 0 0 0' : '5% 0 0 0'}
        value={getUserName}
      />
    </WizzardPageBox>
  )
}

export default WizzardPage0
